export default "__VITE_ASSET__f13edb7b__"